var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#43AC43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 9.96243 9.46243 7.5 12.5 7.5C13.5026 7.5 14.4412 7.76782 15.2496 8.2355C15.4887 8.37377 15.7945 8.29209 15.9328 8.05306C16.0711 7.81403 15.9894 7.50816 15.7504 7.36989C14.7938 6.81654 13.6831 6.5 12.5 6.5C8.91015 6.5 6 9.41015 6 13C6 16.5899 8.91015 19.5 12.5 19.5C16.0899 19.5 19 16.5899 19 13C19 12.7239 18.7761 12.5 18.5 12.5C18.2239 12.5 18 12.7239 18 13C18 16.0376 15.5376 18.5 12.5 18.5C9.46243 18.5 7 16.0376 7 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8536 8.35355C20.0488 8.15829 20.0488 7.84171 19.8536 7.64645C19.6583 7.45118 19.3417 7.45118 19.1464 7.64645L12.5 14.2929L9.85355 11.6464C9.65829 11.4512 9.34171 11.4512 9.14645 11.6464C8.95118 11.8417 8.95118 12.1583 9.14645 12.3536L12.1464 15.3536C12.3417 15.5488 12.6583 15.5488 12.8536 15.3536L19.8536 8.35355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.d078322eb88337e3a5973b04ef2af5f4.svg";
export { ForwardRef as ReactComponent };